import { ExtendedRouteConfig } from '@/router/types';

import DefaultRedirect from '@/domain/default-redirect/components/default-redirect/default-redirect.vue';
import { authenticationRoutes } from '@/application/authentication/routes';
import { productSearchRoutes } from '@/domain/product-search/routes';
import { orderSearchRoutes } from '@/domain/order-search/routes';
import { addressCorrectionRoutes } from '@/domain/address-correction/routes';

export const routes: ExtendedRouteConfig[] = [
  {
    name: 'root',
    path: '/',
    redirect: { name: 'authentication/login' },
    meta: {
      requiresAuth: false,
      alwaysAccessible: true,
    },
  },
  {
    name: 'default',
    path: '/default',
    component: DefaultRedirect,
    meta: { requiresAuth: true },
  },
  {
    path: '/verwaltung',
    component: {
      template: `<div class="admin"><router-view /></div>`
    },
    children: [
      {
        path: '',
        redirect: 'module'
      },
    ],
  },
  ...authenticationRoutes,
  ...productSearchRoutes,
  ...orderSearchRoutes,
  ...addressCorrectionRoutes,
];
